<template>

  <nav class="relative bg-[#0078ce]">
    <div class="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
      <div class="relative flex h-16 items-center justify-between">
        
        <div class="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
          <div class="flex shrink-0 items-center">
            <img src="@/assets/logo_chico.png"  class="h-12 w-auto" />
          </div>      
        </div>
        <div class="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">

          <div class="flex items-center gap-2 my-5">
            <button @click="changeLanguage('es')" class="hover:opacity-70 transition">
              <img src="@/assets/ar.svg" class="h-8" />
            </button>
            <button @click="changeLanguage('en')" class="hover:opacity-70 transition">
              <img src="@/assets/us.svg" class="h-8" />
            </button>
          </div>

        </div>
      </div>
    </div>
  </nav>

</template>

<script lang="ts">
import { defineComponent } from 'vue';
import VueScrollTo from 'vue-scrollto';

import idiomaService from '@/services/idioma.services';

export default defineComponent({
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
    changeLanguage(lang: string) {
      this.$i18n.locale = lang;
      idiomaService.updateIdioma(lang);
    }

  },
});

</script>